import PropTypes from 'prop-types'

import { ModalRoute } from 'components/dialog/Modals'
import RestrictionIpAdd from 'features/restrictionIp/RestrictionIpAdd'
import PageHeader from 'components/PageHeader'
import { Link, useHistory, useRouteMatch } from 'react-router-dom'
import { useConfirm } from 'features/dialog/Confirm'
import RestrictionIpItem from 'features/restrictionIp/RestrictionIpItem'
import Pagination from 'components/pagination/Pagination'
import { useSelector } from 'react-redux'
import Table from 'components/table/Table'
import Button from 'components/form/Button'
import PageSize from 'components/pagination/PageSize'
import Icon from 'components/Icon'

const RestrictionIpListView = ({
  onConfirmDelete,
  onSelectionChange,
  handleCSVFileDownload,
  handlePageChange,
  handleSizeChange,
}) => {
  const {
    restrictionIps,
    selectedIds,
    size,
    page,
    totalElements,
    loading,
    error,
  } = useSelector(state => state.restrictionIp.restrictionIpList)
  const [DeleteConfirm, showDeleteConfirm] = useConfirm()
  const match = useRouteMatch()
  const history = useHistory()

  return (
    <>
      <ModalRoute
        path={`${match.url}/add`}
        className="iplimit_layer"
        closeOnBackgroundClick={false}>
        <RestrictionIpAdd handleClose={() => history.replace(match.url)} />
      </ModalRoute>
      <div className="iplimit_wrap">
        <div className="dsp_tit iplimit_tit">
          <PageHeader pageTitle="광고노출 제한" />
        </div>
        <ul className="list_append">
          <li>
            동일한 사용자가 접속하더라도 IP가 계속 변경되는 유동 IP에 광고
            노출을 제한하고 싶으신 경우에는 마지막 네 번째 자리에
            와일드카드(*)를 사용하면 IP를 차단하실 수 있습니다.
            <br />
            (예 : 192.168.4.*을 노출제한 IP로 등록하면 192.168.4로 시작하는 모든
            IP 주소가 차단됩니다.)
          </li>
          <li>
            유동 IP를 차단할 경우에는 부정적인 목적을 가진 사용자 뿐만 아니라
            다른 유효한 사용자도 차단될 수 있으니 이점 유의해 주시기 바랍니다.
          </li>
        </ul>
        <div className="ad_managebox">
          <div className="managebox_tit">
            <strong className="tit_box">
              총 제한목록 <em className="fc_emph">{totalElements}</em>
            </strong>
            <div className="f_left">
              <div className="single_wrap">
                <Link replace to={`${match.url}/add`} className="btn_gm gm_bl">
                  <span className="inner_g">
                    <span className="img_comm ico_add" />
                    제한 IP 등록하기
                  </span>
                </Link>
              </div>
              <div className="single_wrap">
                <Button
                  line
                  onClick={showDeleteConfirm}
                  disabled={selectedIds.length < 1}>
                  삭제
                </Button>
                <DeleteConfirm
                  title="광고노출 제한 목록 삭제"
                  onClose={onConfirmDelete}>
                  삭제 하시겠습니까?
                </DeleteConfirm>
              </div>
            </div>
            <div className="f_right">
              <div className="single_wrap">
                <Button
                  line
                  icon
                  onClick={handleCSVFileDownload}
                  disabled={totalElements === 0}>
                  <Icon name="download">다운로드</Icon>
                </Button>
              </div>
            </div>
          </div>
          <div className="tblg2_wrap">
            <Table
              className="tbl_g2"
              caption="IP 제한 목록 표"
              emptyMessage={
                <>
                  등록된 제한 IP가 없습니다.
                  <br />
                  <Link to={`${match.url}/add`} className="link_txt">
                    제한 IP 등록하기
                  </Link>
                  를 선택하여 새로운 제한IP를 등록하세요.
                </>
              }
              error={error}
              loading={loading}
              onSelectionChange={onSelectionChange}>
              <Table.Head>
                <Table.Column width={45} checkbox />
                <Table.Column title="등록일시" width={250} />
                <Table.Column title="광고노출 제한 IP" width={250} />
                <Table.Column title="설명" width={630} />
              </Table.Head>
              <Table.Body>
                {restrictionIps.map(restrictionIp => (
                  <Table.Row key={restrictionIp.id} rowId={restrictionIp.id}>
                    <RestrictionIpItem
                      key={restrictionIp.id}
                      data={restrictionIp}
                    />
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
          {totalElements > 0 && (
            <div className="paging_wrap">
              <div className="inner_paging">
                <Pagination
                  current={page}
                  size={size}
                  total={totalElements}
                  onChange={handlePageChange}
                />
                <PageSize
                  onSizeChange={s => {
                    handlePageChange(0)
                    handleSizeChange(s)
                  }}
                  size={size}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default RestrictionIpListView

RestrictionIpListView.propTypes = {
  handlePageChange: PropTypes.func.isRequired,
  handleCSVFileDownload: PropTypes.func.isRequired,
  handleSizeChange: PropTypes.func.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  onConfirmDelete: PropTypes.func.isRequired,
}
